export default __webpack_public_path__ + "572c66ddac9ce25ebd19afde74f83316.svg";